import type { WithPlatformDefaults } from '@lifeomic/service-clients/fhir-client';
import type { Endpoints as MemberOperationsServiceMembersEndpoints } from '@lifeomic/service-clients/member-operations-service-members';
import type { Member } from '../../workflows/utils';

export type FileValidationResolutionAction =
  MemberOperationsServiceMembersEndpoints['POST /v1/member-operations/file-validation/resolutions']['Request']['action'];

export const FILE_VALIDATION_DOCUMENT_REFERENCE_ID_PARAM =
  'fileValidationDocumentReferenceId';

export type InvalidFileDocumentReference =
  WithPlatformDefaults<fhir3.DocumentReference>;

export type FileValidationInvalidReason = {
  code?: string;
  display: string;
  system?: string;
};

export type FileValidationTarget = {
  patient: WithPlatformDefaults<fhir3.Patient>;
  member: Member;
  documentReference: InvalidFileDocumentReference;
  patientId: string;
  documentReferenceId: string;
  invalidReason?: FileValidationInvalidReason;
};

export type FileValidationTargetLookupResult =
  | {
      status: 'success';
      target: FileValidationTarget;
    }
  | {
      status: 'not-found';
    }
  | {
      status: 'subject-mismatch';
      expectedPatientId: string;
      actualPatientId?: string;
    }
  | {
      status: 'error';
      error: unknown;
    };
